import AppConsts from './appconst'
import Util from './Util'
import * as signalR from "@aspnet/signalr";
class SignalRAspNetCoreHelper {
    initSignalR() {
        var encryptedAuthToken = Util.abp.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);
        var url = AppConsts.remoteServiceBaseUrl + 'signalr';
        Util.abp.signalr = {
            autoConnect: true,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encrptedAuthTokenName + "=" + encodeURIComponent(encryptedAuthToken),
            url: 'signalr',
            startConnection: undefined,
            remoteServiceBaseUrl: AppConsts.remoteServiceBaseUrl.substr(0, AppConsts.remoteServiceBaseUrl.length - 1)
        };

        require('./abp.signalr-client.js');
        setTimeout(() => {
            const conn = abp.signalr.hubs.common;
            console.log('conn', conn);
            this.RegistListenning(conn);
        }, 1500);

        //  Util.abp.signalr.connect();
    }
    RegistListenning(connection) {
        connection.on("messageReceived", (data) => {
            console.log(data);
            abp.event.trigger('app.messageReceived', data);
        });

        connection.on("kickOut", (data) => {
            abp.event.trigger('app.kickOut', data);
        })
        connection.on("sendDownTradeSchedule", data => {
            abp.event.trigger('app.sendDownTradeSchedule', data);
        })
        connection.on("logisticsService", data => {
            abp.event.trigger('app.logisticsService', data);
        })
        connection.on("payService", data => {
            abp.event.trigger('app.payService', data);
        })
        connection.on("sendSignalrId", data => {
            console.log("sendSignalrId")
            abp.event.trigger('app.SendSignalrId', data);
        })
        //distributionReceived
        connection.on("distributionReceived", data => {
            abp.event.trigger('app.distributionReceived', data);
        })
        connection.on("SendTrade", data => {
            abp.event.trigger('app.SendTrade', data);
        })

        connection.on("StockIn", data => {
            console.log(data);
            abp.event.trigger('app.StockIn', data);
        })

        connection.on("StockOut", data => {
            abp.event.trigger('app.StockOut', data);
        })

        connection.on("AutoStockOut", data => {
            abp.event.trigger('app.AutoStockOut', data);
        })
        connection.on("TransferStockOut", data => {
            abp.event.trigger('app.TransferStockOut', data);
        })
        connection.on("DeliveryStockOut", data => {
            abp.event.trigger('app.DeliveryStockOut', data);
        })
        //FxBalanceRecharge
        connection.on("FxBalanceRecharge", data => {
            abp.event.trigger('app.FxBalanceRecharge', data);
        })
        //ImportOrder
        connection.on("ImportOrder", data => {
            abp.event.trigger('app.ImportOrder', data);
        })
        connection.on("DeleteOrder", data => {
            abp.event.trigger('app.DeleteOrder', data);
        })
        //AuditRechargeRecord
        connection.on("AuditRechargeRecord", data => {
            abp.event.trigger('app.AuditRechargeRecord', data);
        })
        connection.on("AuditAssist", data => {
            abp.event.trigger('app.AuditAssist', data);
        })
        connection.on("TranferOrder", data => {
            abp.event.trigger('app.TranferOrder', data);
        })
        connection.on("CloundWithDrawApply", data => {
            abp.event.trigger('app.CloundWithDrawApply', data);
        })

        
    }
}
export default new SignalRAspNetCoreHelper();